import type { CheckOffer, OutflowOfferWebProps } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import {
    closeTrialDescriptionModalMobile,
    renderTrialDescriptionModalMobile,
} from 'reactApp/ui/TrialDescriptionModalMobile/TrialDescriptionModalMobile.helpers';

export function checkTrialOffer({ subscription }: CheckOffer) {
    return subscription.isTrial;
}

export function* trialOfferMobile({ subscription, continueOutflow, cancelOutflow }: OutflowOfferWebProps) {
    yield renderTrialDescriptionModalMobile({
        subscription,

        onCancel() {
            closeTrialDescriptionModalMobile();
            continueOutflow();
        },
        onClose() {
            closeTrialDescriptionModalMobile();
            cancelOutflow();
        },
        onSuccess() {
            closeTrialDescriptionModalMobile();
            cancelOutflow();
        },
    });
}
